/**
 * Trustpilot Widget Integration
 */
export default class TrustpilotAnalytics {
	constructor() {
		this.initialize();
	}

	initialize() {
		try {
			this.loadTrustpilotScript();
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Failed to initialize Trustpilot:', error);
		}
	}

	loadTrustpilotScript() {
		if (document.querySelector('script[src*="trustpilot.com"]')) {
			return;
		}

		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src =
			'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
		script.defer = true;

		document.head.appendChild(script);
	}
}
